










































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { showConfirmDialog, generateBlockId, objectToUrlParams, toast } from '@/utils/util'
import { checkTextContent } from '@/utils/utils';
import moduleStore from '../store/textToVideo';

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class SmartTextEntry extends Vue {
  @Prop({ default: false })
  isApp: boolean;

  @Prop({ default: '' })
  text: string;
  errorCount: number = 0;

  // 修改了文案
  @Watch('text')
  async listenText(val) {
    this.recordIds = [];
    if (val && this.isLogin) {
      // 检测文案风险
      const checkRes = await checkTextContent(this, val);
      if (checkRes) return;

      this.textId = generateBlockId();
      const items = [];
      this.checkList.forEach(item => {
        item.generated = false;
        item.generating = false;
        if (item.checked) items.push(item);
      })
      if(items.length) {
        setTimeout(() => {
          this.doGenerate(items);
        }, 200); // 设置200ms后执行，防止清空文本时，触发生成
      }
    } else {
      this.textId = '';
    }
  }

  isLogin = false;
  textId = '';  // 文本id，使用nanoid生成的唯一id
  recordIds = []; // 智能文案生成任务id列表, 用来查询任务状态
  recordTimer = null; // 记录查询定时器
  recordTimerDuration = 5000; // 定时器间隔
  selectedIds = {  // 4个选中的id，与智能文案页面交互使用
    title: '',
    desc: '',
    citation: '',
    rewrite: ''
  }

  activeNames = []; // 展开的面板列表

  // 选择列表
  checkList = [
    {
      id: 'title',
      type: 1,   // 工具类型：1-智能标题、2-智能描述、3-黄金开场、4-文案改写、5-文生图
      name: '智能标题',
      checked: true,  // 是否勾选
      disabled: true, // 是否允许修改
      generating: false, // 是否正在生成
      generated: false, // 是否生成完成，true表示生成完成，false表示未生成
      generateText: '', // 生成的文本
    },
    {
      id: 'desc',
      type: 2,
      name: '智能描述',
      checked: true,
      disabled: true,
      generating: false,
      generated: false,
      generateText: '',
    },
    {
      id: 'citation',
      type: 3,
      name: '黄金开场',
      checked: false,
      generating: false,
      generated: false,
      generateText: '',
      checkTip: '如果你的文案中已经含有黄金开场内容，请不要开启此选项避免开场重复赘述，黄金开场适合没有吸睛开头内容的文案辅助提升作品质量。'
    },
    {
      id: 'rewrite',
      type: 4,
      name: '智能改写',
      checked: false,
      generating: false,
      generated: false,
      generateText: '',
      checkTip: '开启文案改写后会对文章内容进行调整，如果你的文案已经是爆款文案可以不开启此选项，避免爆款内容被改写掉。'
    },
  ]

  // 提交文章的参数
  get smartTextParams() {
    // 没有选中项，不传uniqueId
    const checkedLength = this.checkList.filter(item => item.checked).length;
    if (checkedLength === 0) {
      return {
        articleTransform: 0
      };
    }
    const params = {
      uniqueId: this.textId,
      toolRecordIds: [],
    }

    for (let i = 0; i < this.checkList.length; i++) {
      const item = this.checkList[i];
      // 智能文案 开关
      const switchName = ['', 'titleSwitch', 'subTitleSwitch', 'citationSwitch', 'articleTransform'][item.type];
      params[switchName] = item.checked ? 1 : 0;
      // 智能文案 文本
      if (item.checked && item.generateText) {
        const name = ['', 'title', 'subTitle', 'citation', 'transformContent'][item.type];
        params[name] = item.generateText;
        // 用户选择的工具生成记录id列表
        const toolRecordId = this.selectedIds[item.id];
        if (toolRecordId) params.toolRecordIds.push(toolRecordId);
      }
    }
    return params;
  }

  // 生成状态
  get generateStatus() {
    const checkedLength = this.checkList.filter(item => item.checked).length;
    if (checkedLength === 0) return 'none';
    if (!this.textId) return 'empty';
    const generatedLength = this.checkList.filter(item => item.checked && item.generated).length;
    if (generatedLength < checkedLength) return 'loading';
    return 'done';
  }
  // 正在生成的列表，用来显示loading的内容
  get isGenerateList() {
    return this.checkList.filter(item => item.checked && !item.generated);
  }
  // 已经生成的内容字符串，用来显示done的标题
  get hasGeneratedStr() {
    return this.checkList
      .filter(item => item.checked && item.generated)
      .map(item => item.name.replace('智能', ''))
      .join('、');
  }

  mounted() {
    const ww_token = localStorage.getItem('ww_token');
    this.isLogin = !!ww_token;
    window.addEventListener('storage', this.storageEvent);
  }
  destroy() {
    window.removeEventListener('storage', this.storageEvent);
  }
  // 智能文案页面后退，监听storage，将选中的智能文案id设置过来，并请求接口获取
  storageEvent(event: StorageEvent) {
    const { key, newValue } = event;
    if (key === 'smartTextSelectedIds' && newValue) {
      const selectedIds = JSON.parse(newValue);
      for (const name in selectedIds) {
        if (Object.prototype.hasOwnProperty.call(selectedIds, name)) {
          const recordId = selectedIds[name];
          const checkItem = this.checkList.find(item => item.id === name);
          if (recordId) {
            if (!checkItem.checked) checkItem.checked = true; // 设置选中
            if (this.selectedIds[name] !== recordId && this.recordIds.indexOf(recordId) === -1) {
              this.recordIds.push(recordId);
            }
            this.selectedIds[name] = recordId; // 设置选中的id，注意取消勾选时不能删除，需要记住该id和文本值
          } else if (!recordId && !checkItem.disabled && checkItem.checked) { // 如果取消勾选，则不设置选中
            checkItem.checked = false;
          }
        }
      }
      this.doQueryRecordList();
    }
  }
  // 点击勾选
  async doCheck(item) {
    if (item.disabled && item.checked) return;
    if (!this.isLogin) {
      this.doJumpLogin();
      return;
    }
    if (!item.checked) { // 从不勾选改为勾选
      if (item.checkTip) {
        const isConfirm = await showConfirmDialog({
          title: '温馨提示',
          message: item.checkTip,
          confirmButtonText: '开启',
          cancelButtonText: '不开启',
          closeOnClickOverlay: true,
        })
        if(!isConfirm) return;
      }
      this.doGenerate([item]);
    }
    item.checked = !item.checked;
  }
  // 进行生成
  async doGenerate(items) {
    if (!this.textId) return;
    const needItems = items.filter(item => !(item.generated || item.generating)); // 已经有了/正在生成，不需要重复生成
    const ids = needItems.map(item => {
      item.generating = true;
      return item.id.toLocaleUpperCase();
    });
    if (!ids.length) return;
    const params = {
      uniqueId: this.textId,
      types: ids,
      content: this.text
    }
    const res = await this.$http('batchGenerateSmartText', params);
    if (res.code === 200 && res.data && res.data.length) {
      res.data.forEach(task => {
        this.recordIds.push(task.id);
        const checkItem = needItems.find(v => v.type === task.type); // 找到对应的勾选项
        if (checkItem) {
          this.selectedIds[checkItem.id] = task.id;
        }
      })
      this.getRecordList();
    } else {
      needItems.forEach(item => {
        item.generating = false;
      })
      this.generateError(needItems);
    }
  }

  generateError(checkItems) {
    this.errorCount += 1;
    if (this.errorCount < 3) {
      toast('智能文案生成失败，重新为您生成'); // 给个提示
      this.doGenerate(checkItems);
    } else {
      toast('智能文案生成失败，请稍后重试');
      checkItems.forEach(item => {
        item.checked = false;
      })
    }
  }
  // 判断获取生成记录
  async getRecordList() {
    if (!this.textId) return;
    clearTimeout(this.recordTimer);
    if (this.recordIds.length) {
      this.recordTimer = setTimeout(() => {
        this.doQueryRecordList();
      }, this.recordTimerDuration);
    }
  }
  // 请求生成记录
  async doQueryRecordList() {
    if (this.recordIds.length === 0) return;
    const res = await this.$http('getSmartTextbyIds', { recordIds: this.recordIds });
    if (res.code === 200 && res.data) {
      const list = res.data || [];
      const errorItems = [];
      for (let index = 0; index < list.length; index++) {
        const task = list[index];
        const checkItem = this.checkList.find(v => v.type === task.type);
        const recordIndex = this.recordIds.findIndex(v => v === task.id);
        if (task.status !== 1 && recordIndex > -1) { // 成功/失败都要删除轮询列表
          this.recordIds.splice(recordIndex, 1);
        }
        checkItem.generated = task.status === 2;  // 生成完成
        checkItem.generating = task.status === 1; // 正在生成
        if (task.status === 2) { // 成功
          checkItem.generateText = task.output && task.output.content || '';
        } else if (task.status === 3) { // 失败
          errorItems.push(checkItem);
        }
      }
      if (errorItems.length) {
        this.generateError(errorItems);
      }
      const isloadingTaskLength = list.filter(v => v.status === 1).length;
      if (isloadingTaskLength > 0) {
        this.recordTimer = setTimeout(() => {
          this.doQueryRecordList();
        }, this.recordTimerDuration);
      }
    }
  }

  // 跳转智能文案页面
  doJumpAiPage({ id }) {
    const obj = {
      tabId: id,
      uniqueId: this.textId,
      titleId: this.selectedIds.title,
      descId: this.selectedIds.desc,
      citationId: this.selectedIds.citation,
      rewriteId: this.selectedIds.rewrite,
    }
    // 取消勾选后置空
    for (let index = 0; index < this.checkList.length; index++) {
      const item = this.checkList[index];
      if (!item.checked) obj[item.id + 'Id'] = '';
    }
    console.log('obj', obj);
    const linkUrl = window.location.origin + `/#/smartText?${objectToUrlParams(obj)}`;
    if (this.isApp) {
      let switchWebviewUrl = (<any>window).switchWebviewUrl;
      switchWebviewUrl.postMessage(linkUrl + '&open=true'); // 拼接open=true，app会重新打开一个webview页面，后退到回来内容不刷新
    } else {
      this.$navigateTo({
        url: '/pages/webview/webview?url=' + encodeURIComponent(linkUrl),
      })
    }
  }

  doJumpLogin() {
    if (this.isLogin) return;
    this.$emit('login');
  }
}
